// make toggle/switch from checkbox
window.initToggles = () => {
    if (window.toggleInitClass) {
        $('.' + toggleInitClass).bootstrapToggle()
    }
    $('.toogle').bootstrapToggle()
}

$(document).ready(function () {
    initToggles()
})
